"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CollapseButton;
var _collapse = _interopRequireDefault(require("./collapse"));
var _button = _interopRequireDefault(require("./button"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Forbes is what I'm doing here right
// Particularly with extending ButtonProps and also useState

function CollapseButton(props) {
  const [isOpened, toggleOpened] = (0, _react.useState)(props.defaultToOpened || false);
  const {
    children,
    defaultToOpened,
    hideName,
    showName,
    transitionMS,
    ...buttonProps
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_button.default, _extends({}, buttonProps, {
    onClick: () => toggleOpened(!isOpened)
  }), isOpened ? hideName || 'Hide' : showName || 'Show')), /*#__PURE__*/_react.default.createElement(_collapse.default, {
    isOpened: isOpened,
    transitionMS: transitionMS
  }, children));
}